import Vue from "vue";
import Vuex from "vuex";
import { RootState } from "./root-state";

Vue.use(Vuex);

export default new Vuex.Store<RootState>({
  mutations: {},
  actions: {},
  modules: {}
});
